const TITLE = {
	size: 'l',
	className: '--sueca --font-bold',
};

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {TITLE};
